import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { LogOut } from 'react-feather';
import secureLocalStorage from 'react-secure-storage';

const AccountBar = ({ name }) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const displayName = name || 'Partner';
  // const initial = displayName.trim().charAt(0).toUpperCase() || 'P';

  const handleLogout = () => {
    secureLocalStorage.removeItem('tokenPartner');
    secureLocalStorage.removeItem('partnerName');
    window.location.href = '/';
  };

  return (
    <div className="account-bar">
      <div className="account-info">
        {/* <div className="account-avatar">{initial}</div> */}
        <div style={{ minWidth: 0 }}>
          <p className="account-hi">Selamat datang,</p>
          <p className="account-name">{displayName}</p>
        </div>
      </div>

      <button
        type="button"
        className="account-logout"
        onClick={() => setShowConfirm(true)}
      >
        <LogOut size={16} />
        Keluar
      </button>

      <Modal show={showConfirm} centered onHide={() => setShowConfirm(false)}>
        <Modal.Body>
          <div className="co-modal-body">
            <p className="co-modal-title">Keluar dari Akun?</p>
            <p className="co-modal-sub">
              Kamu perlu login kembali untuk masuk.
            </p>
            <div className="co-modal-actions">
              <button
                type="button"
                className="co-modal-btn cancel"
                onClick={() => setShowConfirm(false)}
              >
                Batal
              </button>
              <button
                type="button"
                className="co-modal-btn confirm"
                onClick={handleLogout}
              >
                Ya, Keluar
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AccountBar;
